import { Dtos, SuretyAccountId, WorkInProgressStatementId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { logError } from "../../utils/error";
import { useRequest } from "../../utils/request";
import { wipQueryKey } from "./account.keys";

export const useUpdateWorkInProgressStatement = (accountId: SuretyAccountId) => {
	const { put } = useRequest();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: async ({
			wipId,
			data,
		}: {
			wipId: WorkInProgressStatementId;
			data: Dtos.WipStatement.Update.Request;
		}): Promise<void> => {
			await put(
				`/v2/surety/accounts/${accountId}/work-in-progress-statements/${wipId}`,
				data,
				"none",
			);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: wipQueryKey(accountId) });
		},
		onError: (error: Error) => {
			logError(error);
		},
	});

	return {
		updateWipStatement: mutation.mutateAsync,
		updateWipStatementIsLoading: mutation.isPending,
		updateWipStatementError: mutation.error,
		resetUpdateWipStatementError: mutation.reset,
	};
};
